import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5qsb0hdt: FaireBrandEntity = {
  token: "b_5qsb0hdt",
  type: "brand",
  name: "Belle's Nest",
  avatarUrl:
    "https://cdn.faire.com/fastly/cc783401f6c7947d521fc0abfc85bb9a18984f2bdab3bebaa6c037e915d575fd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7e5f20a2bdc8e8591abdec100b3fddfdd0b3060f14c90387a94d5d2984ff91f0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cc783401f6c7947d521fc0abfc85bb9a18984f2bdab3bebaa6c037e915d575fd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7e5f20a2bdc8e8591abdec100b3fddfdd0b3060f14c90387a94d5d2984ff91f0.jpeg",
  location: "Monrovia, CA, USA",
  minimumOrderDollars: 205,
  rating: 5,
  reviewCount: 83,
  isInsider: true,
  description:
    "Welcome!  Belle's Nest began in a brick and mortar in Sierra Madre, Ca in 2008. The intention was to bring together local artisans and handcrafted items. After 10 wonderful years I closed and left my location in order to focus more on my own designs and creative work. Prior to Belle's Nest I had another shop, DUSK in Pasadena, Ca that I opened in my early 20's which lasted 10 years as well. That being said, 20 years has brought me endless knowledge and experience. In addition I am a self taught jewelry maker working primarily in Sterling Silver. Any jewelry that you see available is made personally by me. \n\nMy home studio is located at the foothills of the San Gabriel mountains in Southern California and I am a Los Angeles native. \nI love small batch goods that are unique, colorful and tell a story. \nI handpick all of my quilts and materials.\nAll products are made in my studio with the exception of my ornaments. \n\nThank you for visiting,  xo Gloria",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:00.612Z",
    importedBy: "entity-db-cli",
  },
};
